import { render } from "./GroupConversation.vue?vue&type=template&id=0e977fa6"
import script from "./GroupConversation.vue?vue&type=script&lang=js"
export * from "./GroupConversation.vue?vue&type=script&lang=js"
script.render = render

export default script